import LocalStorageService from '../LocalStorageService'
import jwt_decode from 'jwt-decode'
import {
  unauthorizedAdminRoutePath,
  unauthorizedRoutePath
} from '../../routes/routePaths'
import history from '../../store/history'

export const isAuthenticated = () => {
  const token = LocalStorageService.get('token')
  if (token) {
    const decoded = jwt_decode(token)
    if (!decoded || decoded.exp < Date.now() / 1000) {
      LocalStorageService.remove('token')
      return false
    }
    return true
  }
  return false
}

export const getUserRole = () => {
  const token = LocalStorageService.get('token')
  if (token) {
    const decoded = jwt_decode(token)
    return decoded.role
  }
  return null
}

export const isAlreadyInUnauthorizedRoute = () => {
  const [actualPath] = history.location.pathname.split('?')
  return (
    actualPath.includes(unauthorizedRoutePath) ||
    actualPath.includes(unauthorizedAdminRoutePath)
  )
}
